import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Async thunk for fetching gold data
export const mmtcGoldApi = createAsyncThunk(
  "mmtcmmtcGoldApi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/customTrade/getNonExecutableQuote",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const mmtcGoldSlice = createSlice({
  name: "mmtcGoldSlice",
  initialState: {
    data: [],
    error: null,
    loading: false,
  },
  reducers: {
    resetGoldState: (state) => {
      state.data = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mmtcGoldApi.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on new request
      })
      .addCase(mmtcGoldApi.fulfilled, (state, action) => {
        state.data = action.payload ?? []; // Ensure data is always an array
        state.loading = false;
      })
      .addCase(mmtcGoldApi.rejected, (state, action) => {
        state.error = action.payload || "Failed to fetch gold data"; // Store latest error
        state.loading = false;
      });
  },
});

export const { resetGoldState } = mmtcGoldSlice.actions;
export default mmtcGoldSlice.reducer;
